import { render, staticRenderFns } from "./DataCompare.vue?vue&type=template&id=a36cf010"
import script from "./DataCompare.vue?vue&type=script&lang=js"
export * from "./DataCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports